module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="content-header">\r\n    <h1>\r\n        '+
((__t=(lang.COMPANIES))==null?'':_.escape(__t))+
'\r\n            <small></small>\r\n    </h1>\r\n</section>\r\n\r\n<section class="content">\r\n    <div class="row">\r\n        <div class="col-md-12 folderView">\r\n\r\n            ';
 if(role==="0")
                print(  '<div class="box_simple_iiii  col-lg-3 col-md-4 col-sm-6 col-xs-12"><div class="info-box">' + 
                            '<span class="info-box-icon bg-green pointer" id="addCompany"><i class="ion ion-ios-plus-outline"></i></span>' + 
                            '<div class="info-box-content">'+
                                '<span class="info-box-text">' + lang.ADD + '</span>'+
                                '<span class="info-box-number">' + lang.COMPANIES + '</span>' +
                            '</div>' +
                        '</div></div>');
            
__p+='\r\n\r\n\r\n                ';

            _.each(models, function(model){
                print(  '<div class="box_simple_iiii col-lg-3 col-md-4 col-sm-6 col-xs-12"><div class="info-box">' + 
                        '<span class="info-box-icon bg-yellow company pointer" data-id="' + model.id + '"><i class="ion ion-ios-folder-outline"></i></span>' + 
                        '<div class="info-box-content">'+                            
                        '<span class="info-box-number">' + model.attributes.name + '</span>');
                            
                if(role==="0"){
                    print(  '<span class="info-box-text"><span data-id="' + model.id + '" class="btn btn-flat btn-default btn-sm editCompany">' + lang.EDIT + '</span></span>');    
                }

                print(  '</div></div></div>');
            });
            
__p+='\r\n        </div>\r\n\r\n    </div>\r\n</section>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/companies/companiesView.ejs
// module id = 411
// module chunks = 0